import baseWorkloadApi from './baseWorkloadApi';
import type { SellerDashboardResponse } from './leads.api';

const sellerDashboardApi = baseWorkloadApi.injectEndpoints({
  endpoints: (build) => ({
    getSellerDashboard: build.query<
      SellerDashboardResponse,
      {
        businessUnitId: number;
        startDate?: string;
        endDate?: string;
        brands?: string[];
        branchOffices?: string[];
      }
    >({
      query: (params) => ({
        url: '/leads/seller-dashboard',
        method: 'GET',
        params: {
          businessUnitId: params.businessUnitId,
          ...(params.startDate ? { startDate: params.startDate } : {}),
          ...(params.endDate ? { endDate: params.endDate } : {}),
          ...(params.brands && params.brands.length > 0 ? { brands: params.brands.join(',') } : {}),
          ...(params.branchOffices && params.branchOffices.length > 0
            ? { branchOffices: params.branchOffices.join(',') }
            : {}),
        },
      }),
      transformResponse: (response: SellerDashboardResponse) => response,
    }),
  }),
  overrideExisting: false,
});

export const { useGetSellerDashboardQuery } = sellerDashboardApi;
